<template>
  <InfoTooltip small>
    <template #element>
      <div class="file-tag__container" :class="fileError">
        <Spinner
          v-if="loading"
          size="14"
          line-fg-color="#7E8186"
          line-size="1"
          line-bg-color="transparent"
        />
        <FileIcon v-else class="icon-g-500 icon-14px" />
        <span
          class="file-tag__name text-sm"
          :class="{
            file_uploaded: isUploaded,
            'file-tag__name_loading': loading,
          }"
        >
          {{ fileName }}
        </span>
        <span v-if="!isUploaded" class="file-percent"> &nbsp;{{ file.percent }}% </span>
        <button class="file-tag__delete-button" type="button" @click="$emit('delete', file)">
          <DeleteIcon />
        </button>
      </div>
    </template>
    <div class="file-tag__tooltip">
      {{ fileName }}
    </div>
  </InfoTooltip>
</template>

<script>
  import DeleteIcon from '@/assets/icons/x.svg';
  import fileName from '@/utils/formatting/file-name';
  import FileIcon from '@/assets/icons/file-blue.svg';
  import Spinner from 'vue-simple-spinner';
  import InfoTooltip from '@/components/ui/InfoTooltip';

  export default {
    name: 'AttachedFile',
    components: {
      FileIcon,
      DeleteIcon,
      Spinner,
      InfoTooltip,
    },
    props: {
      file: {
        type: Object,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      showTooltip: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      fileName() {
        return fileName(this.file?.name || this.file?.file?.name || this.file || '');
      },
      isUploaded() {
        return this.file.id || this.file.percent === 100 || !this.file.uploading;
      },
      fileError() {
        return { 'file-tag__container_error': this.file.formatError };
      },
      tooltipText() {
        return this.file.errorText ? this.file.errorText : this.fileName;
      },
    },
  };
</script>
